
import { IconButton, Typography } from "@mui/material"
import { oilChangeColNm } from "./constant"
import { ArticleRounded } from "resource/muiImport"
import { numberFormat, dateFormat } from "utils"
import dayjs from "dayjs"

const getDueStatus = (row) => {
  if (!row.NxtDte && !row.NxtMileage) return null
  const now = dayjs()
  if (row.NxtDte) {
    const nxt = dayjs(row.NxtDte)
    if (nxt.isBefore(now, 'day')) return 'overdue'
    if (nxt.diff(now, 'day') <= 7) return 'soon'
  }
  return 'ok'
}

const dueColors = {
  overdue: "error.main",
  soon: "warning.main",
  ok: "success.main",
}

const dueLabels = {
  overdue: "เกินกำหนด",
  soon: "ใกล้กำหนด",
  ok: "ปกติ",
}

export const oilChangeColumns = [
  {
    field: 'ShowDetail',
    headerName: '',
    width: 40,
    align: 'center',
    renderCell: () => (
      <IconButton size="small">
        <ArticleRounded color="primary" />
      </IconButton>
    )
  },
  {
    field: "No",
    headerName: "No.",
    width: 50,
    align: 'center',
  },
  {
    field: "TukCd",
    headerName: oilChangeColNm.TukId,
    width: 100,
  },
  {
    field: "SpNm",
    headerName: oilChangeColNm.SpId,
    width: 150,
  },
  {
    field: "ChgDte",
    headerName: oilChangeColNm.ChgDte,
    width: 110,
    valueFormatter: ({ value }) => dateFormat(value),
  },
  {
    field: "Mileage",
    headerName: oilChangeColNm.Mileage,
    width: 110,
    align: "right",
    valueFormatter: ({ value }) => value ? numberFormat(value) : "-",
  },
  {
    field: "Qty",
    headerName: oilChangeColNm.Qty,
    width: 90,
    align: "right",
    valueFormatter: ({ value }) => value ? numberFormat(value) : "-",
  },
  {
    field: "TotalPr",
    headerName: oilChangeColNm.TotalPr,
    width: 100,
    align: "right",
    valueFormatter: ({ value }) => value ? numberFormat(value) : "-",
  },
  {
    field: "NxtMileage",
    headerName: oilChangeColNm.NxtMileage,
    width: 140,
    align: "right",
    valueFormatter: ({ value }) => value ? numberFormat(value) : "-",
  },
  {
    field: "NxtDte",
    headerName: oilChangeColNm.NxtDte,
    width: 140,
    valueFormatter: ({ value }) => dateFormat(value),
  },
  {
    field: "DueStatus",
    headerName: "สถานะ",
    width: 90,
    align: 'center',
    renderCell: ({ row }) => {
      const status = getDueStatus(row)
      if (!status) return "-"
      return (
        <Typography variant="body2" sx={{ color: dueColors[status], fontWeight: 'bold' }}>
          {dueLabels[status]}
        </Typography>
      )
    }
  },
  {
    field: "SupSNm",
    headerName: oilChangeColNm.SupId,
    width: 120,
  },
  {
    field: "Dscp",
    headerName: oilChangeColNm.Dscp,
    flex: 1,
    minWidth: 120,
  },
]
